import * as React from 'react';
import env from 'src/shared/env';
import './AccountInfoFooter.scss';

export function AccountInfoFooter(props: any) {
  const { t } = props;
  return (
    <div className="rp-accountinfofooter">
      <span>
        {env.REACT_APP_BASE_ENVIRONMENT === 'US'
          ? `${t('accountInfoHeader.assistanceTxt')}`
          : `${t('accountInfoHeader.assistanceCATxt')}`}
      </span>
    </div>
  );
}
